import { CreateOrgComponent } from "./create-org/createorg.component";
import { EditOrgComponent } from "./edit-org/editorganization.component";
import { SingleOrgViewComponent } from "./view-org/single-view-org.component";
import { ViewOrgComponent } from "./view-org/vieworg.component";

export const MasterOrgRouting = [
    {path: '', redirectTo: 'view-org', pathMatch: 'full'},
    { path: 'create-org', component: CreateOrgComponent},
    { path: 'view-org', component: ViewOrgComponent},
    { path: 'edit-org/:orgID', component: EditOrgComponent},
    { path: 'single-view-org/:orgID', component: SingleOrgViewComponent},

];

export const MasterOrgRoutingBreadcrumbs = [
    { name:'Create', path: 'create-org'},
    { name:'View', path: 'view-org'},
    { name:'Edit', path: 'edit-org'},
    { name:'Single View', path: 'single-view-org'},
]